import { Component } from '@angular/core';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-team-message-detail-dialog',
  standalone: true,
  imports: [
    MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './team-message-detail-dialog.component.html',
  styleUrl: './team-message-detail-dialog.component.css'
})
export class TeamMessageDetailDialogComponent {
  textToShow = '3';
  text = ["2", "1", "0"];
  inst = setInterval(() => this.change(), 1000);
  counter = 0;
  constructor(          
    translate: TranslateService,    
  ) {
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);    
  }
  change(): void {
    this.textToShow = this.text[this.counter];
    this.counter++;
    if (this.counter >= this.text.length) {
      this.counter = 0;
      // uncomment this if you want to stop refreshing after one cycle
      clearInterval(this.inst); 
    }
  }
}
